import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupUsers } from '../redux/actions/clients';
import { StoreState } from '../types/state';

const useClientGroupUsers = (id: string) => {
  const groupUsers = useSelector((state: StoreState) => {
    return state.clients.groupUsers[id];
  });

  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!groupUsers) {
      setIsLoading(true);
      dispatch(getGroupUsers(id));
    } else {
      setIsLoading(false);
    }
  }, [groupUsers, dispatch, id]);
  return { groupUsers, isLoading };
};

export default useClientGroupUsers;
